// Core
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// Chakra imports
import { Box } from '@chakra-ui/react';

// Components
import Station from './Station';
import StationsEdit from './StationsEdit';
import usePermissionStatusByKey from '../../../hooks/usePermissionStatusByKey';

function Stations(props) {
  const { path } = useRouteMatch();

  const isStations = usePermissionStatusByKey('GET:/admin/stations');
  const isCreateStations = usePermissionStatusByKey('POST:/admin/stations');

  return (
    <>
      <Box>
        <Switch>
          <Route
            path={`${path}/:id(new|\\d+)`}
            render={() => <StationsEdit />}
          />
          {(isStations || isCreateStations) && (
            <Route path={`${path}`} render={() => <Station />} />
          )}
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default Stations;
